module.exports = __webpack_public_path__ + "static/media/integration-wizard-welcome.15e34a7b.png";